import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PopUpHelper } from '../service/helper/popup-helper';
import { AuthenticationService } from '../service/authentication.service';
import { HttpHelperService } from '../service/helper/http/http-helper.service';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {

  public loginForm: FormGroup;
  public resetPasswordForm: FormGroup;
  public submitted = false;
  public submittedMobile = false;
  public resetPasswordSubmitted = false;
  public isLoginFormVisible = true;
  private relativeCommonUrl1  = 'api/auth/';
  constructor(private httpClientService: HttpHelperService,
              private router: Router,private formBuilder: FormBuilder,private authService:AuthenticationService) {
                this.resetPasswordSubmitted=false;
               }

  ngOnInit() {
    this.resetPasswordSubmitted=false;
    localStorage.removeItem('userPermissionModule');
    localStorage.removeItem('permissionConfigModuleBeans');
    this.roleName = localStorage.getItem('roleName');
    this.initilaizeForm();
  }
  ionViewWillEnter(){
    this.initilaizeForm();
  }
  public initilaizeForm(){
    this.loginForm = this.formBuilder.group({
      email: ['',Validators.required],
      password: ['',Validators.required],
    });
    this.resetPasswordForm = this.formBuilder.group({
      email: ['',Validators.required],
    });

  }
  error="";
  validemailcheck:boolean=false;
  checkEmail(){
    this.validemailcheck=false;
    var test = this.resetPasswordForm.value;
    const emailPattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    if(test.email !== null && typeof test.email !== "undefined") {
      if (!emailPattern.test(test.email)) {
        this.error="Please enter valid email-ID!"
      }else{
        this.error="";
        this.httpClientService.getRequest(this.relativeCommonUrl1+'checkEmailInUse?email='+test.email,null)
    .subscribe(
        data => { 
         if(data.data=="false")
         {
          this.error=""
         }
         else{
          // 
          this.validemailcheck=true;
          // this.leadEmailAddressErrMsg=true
         }
        },error=>{
            },()=>{});
      }
    }
    
          }
  signIn(){
    if(this.loginForm.invalid){
      this.submitted = true;
      return;
    }
  //  console.log(this.loginForm.value);
    const data = {
      "deviceId": "",
      "email": this.loginForm.value.email,
      "fcmToken": "",
      "password": this.loginForm.value.password
    };
    // const data = {
    //   "deviceId": "",
    //   "email": "pradip.hipparkar@technohertz.com",
    //   "fcmToken": "",
    //   "password": "Admin@123"
    // };
    this.httpClientService.postRequest('api/auth/login',data)
    .subscribe((response)=>{
      
      if(response.success==false){
        const result = PopUpHelper.confirmPopUp(response.data);
        this.router.navigate(['/login']);
      }else{
        this.authService.setUserInfo(response);
        localStorage.setItem('accessToken',response.accessToken);
        localStorage.setItem('refreshToken',response.refreshToken);
        sessionStorage.setItem('userType',response.userProfile?.userType);
        localStorage.setItem('roleName',response?.roles[0]?.role);
        localStorage.setItem('loggedInUserID',response.userProfile.id);
        this.roleName = response?.roles[0]?.role
        this.userPermissionBtId();
      }
      
    });
  }
  userPermissionModule:any=[];
  permissionConfigModuleBeans:any=[]
  private relativeproUrl = 'api/users/user-permissions';
  roleName:any;
  userPermissionBtId(){
    this.httpClientService.postRequest(this.relativeproUrl, null).subscribe((response) => {
      this.loginForm.reset();
      if(this.roleName == 'ROLE_WOMAN_ADMIN' || this.roleName == 'ROLE_WOMAN_SECURITY'){
        this.router.navigate(['/home/womens-safety-dashboard']);
      }else{
        this.router.navigate(['/home/dashboard']);
      }
      for(let i=0;response.data.permissions.length>i;i++){
        this.userPermissionModule=response.data.permissions[i].permissionModuleBeans;
        this.permissionConfigModuleBeans=response.data.permissions[i].permissionConfigModuleBeans
        localStorage.setItem('userPermissionModule',JSON.stringify(this.userPermissionModule));
        localStorage.setItem('permissionConfigModuleBeans',JSON.stringify(this.permissionConfigModuleBeans));
      }
    });
  }
  backToLogin(){
    this.loginForm.reset();
    this.isLoginFormVisible = true;
  }
  openPasswordResetPasssword(){
    this.resetPasswordForm.reset();
    this.isLoginFormVisible = false;

  }
  resetPassword(){
    if(this.validemailcheck==true){
    this.resetPasswordSubmitted = true;
    if(this.resetPasswordForm.invalid){
      return;
    }
    this.httpClientService.postRequest('api/auth/password/resetlink',{email:this.resetPasswordForm.value.email})
    .subscribe((response)=>{
      if(response.success==true){
        window.alert("A link has been sent to your registered email id to reset the password");
        this.isLoginFormVisible = true;
        this.resetPasswordSubmitted=false;
      }
    
    });
  }
  else{window.alert("Please enter your registered email id");

  }
}
  // onclickSubmitForgetPassword(){
  //   this.router.navigate(['/forget-password']);
  // }
  public segment: string = "Admin";
  loginUserForm:FormGroup;
  showOtpScreen: boolean = false;
  mobileNumber:any;
  loginOtpUserForm:FormGroup;
  segmentChanged(ev: any) {
    this.segment = ev.detail.value;
    if(this.segment == 'MobileUser')
    this.loginUserForm = this.formBuilder.group({
      mobileNo: ['',Validators.required],
    });
  }
  generateOtp(){
    if(this.loginUserForm.invalid){
      this.submittedMobile = true;
      return;
    }
    const request = {  
      "contactNo": this.loginUserForm.value.mobileNo,
    }
    this.httpClientService.postRequest('api/auth/send-generated-otp',request)
    .subscribe((response)=>{
      this.mobileNumber = response?.data?.mobileNumber;
      window.alert("OTP sent successfully.");
      this.loginOtpUserForm = this.formBuilder.group({
        otp: ['',Validators.required],
      });
      this.showOtpScreen = true;
    });
  }
  confirmOtp(){
    if(this.loginOtpUserForm.invalid){
      this.submittedMobile = true;
      return;
    }
    const request = {  
      "mobileNumber": this.mobileNumber,
      "otp": this.loginOtpUserForm.value.otp,
    }
    this.httpClientService.postRequest('api/auth/validate-otp',request)
    .subscribe((data)=>{
      if(data.status==true){
        //Test
        // window.open('https://thzretail.com/safetyFirstInUser/safetyFirstIn/dashboard?accessToken='+data.data.accessToken+'&getuserID='+data.data.userProfile?.id+'&loggedInUserName='+data.data.userProfile?.firstName+' '+data.data.userProfile?.lastName
        //  +'&loggedInUserType='+data.data.userProfile?.userType+'&getrefreshToken'+data.data.refreshToken+'&loginStatus='+'true'+'&contactNo='+data.data.userProfile?.contactNo,'_self');
        //Prod
         window.open('https://safetyfirstin.com/safetyFirstInUser/safetyFirstIn/dashboard?accessToken='+data.data.accessToken+'&getuserID='+data.data.userProfile?.id+'&loggedInUserName='+data.data.userProfile?.firstName+' '+data.data.userProfile?.lastName
         +'&loggedInUserType='+data.data.userProfile?.userType+'&getrefreshToken'+data.data.refreshToken+'&loginStatus='+'true'+'&contactNo='+data.data.userProfile?.contactNo,'_self');
      }
    });
  }
private encryptSecretKey:any="thzHSESkoda!@#"
encryptData(data) {
  try {
    return CryptoJS.AES.encrypt(JSON.stringify(data), this.encryptSecretKey)
  } catch (e) {
    console.log(e);
  }
  }
}
